import styles from './tailwind.css';
import { cssBundleHref } from '@remix-run/css-bundle';
import type { LinksFunction } from '@remix-run/node';
import { rootLoader } from './pages/root/loaders';
import { RootPage } from './pages/root';

export const links: LinksFunction = () => [
...(cssBundleHref ? [{ rel: 'stylesheet', href: cssBundleHref }] : []),
{ rel: 'stylesheet', href: styles },
{
  rel: 'stylesheet',
  crossOrigin: 'anonymous',
  href: 'https://use.typekit.net/qrq8jit.css'
}];


export const loader = rootLoader;

export default RootPage;